
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/investments-hero.webp';
import highResMobileImageWebp from './images/investments-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImage';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='investments-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Investments'
      headingText={<>Invest in your <WidowBlock>best life.</WidowBlock></>}
      descriptionText={<>Our long&#45;term approach to investing and wide range of options will help you live the life you want&#8212;no matter where you&#39;re starting from.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start investing',
        ariaLabel: 'Start investing with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='A couple laughing together on a boat at sea'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
